import { Fragment, useState } from 'react';
import { View } from 'react-native';

import themeStyle from '../../Theme/styles';

import ResponsiveText from '../ResponsiveText';

import { ByCountProps } from './types';

const ReadMoreByCount = ({
  category = 'p1',
  contentContainerStyle,
  maxChar,
  status = 'success',
  value,
}: ByCountProps) => {
  const [show, setShow] = useState<boolean>();
  const isSeeMore = value?.length > maxChar;
  if (!value) return null;
  return (
    <View style={[contentContainerStyle, themeStyle.flexDirectionRow]}>
      <ResponsiveText category={category}>
        {value.substring(0, show ? undefined : maxChar - 3)}
        {isSeeMore && (
          <Fragment>
            {!show ? '...' : ''}
            <ResponsiveText
              category={category}
              status={status}
              onPress={() => setShow((prev) => !prev)}
            >
              {' '}
              {show ? 'See Less' : 'See More'}
            </ResponsiveText>
          </Fragment>
        )}
      </ResponsiveText>
    </View>
  );
};

export default ReadMoreByCount;
